import { useEffect } from 'react';
import { COUNTRY } from '~globals';
import { useMarketingParams } from '~components/MarketingParamsProvider';
import { useProspectId } from '~components/ProspectProvider';
import { MarketingCommandsDe } from '~models/commands-de';
import { useCommandsDe } from './useCommandsDe';

type Partner = MarketingCommandsDe['usePartner']['partner'];

export const useDeDistributionPartner = (partner?: Partner) => {
  const { prospectId } = useProspectId();
  const { sendCommand } = useCommandsDe();
  const { marketingParams } = useMarketingParams();

  useEffect(() => {
    if (partner && prospectId && COUNTRY === 'de') {
      void sendCommand('usePartner', {
        partner,
        externalCustomerId: marketingParams?.finomClientId,
      });
    }
  }, [partner, prospectId]);
};
